import clsx from 'clsx';
import { useNavigate } from 'react-router-dom';
import ButtonMenu from '~/components/buttons/ButtonMenu';
import useRouteMatch from '~/hooks/useRouteMatch';
import IconChervonDown from '~/icons/icon-chevron-down.svg?react';
import styles from './CollapsedTab.module.scss';
import { type NavigationTabProps } from '../NavigationTabBar/NavigationTabBar';

interface CollapsedTabsProps {
  tabs: NavigationTabProps[];
  className?: string;
  defaultString?: string;
  onSelect?: (tab: NavigationTabProps) => boolean | void;
  ref?: React.Ref<HTMLDivElement>;
}

const CollapsedTab: React.FC<CollapsedTabsProps> = ({ tabs, className, onSelect, defaultString, ref }) => {
  const currentTab = useRouteMatch(tabs.map((tab) => tab.path));
  const label = tabs.find((tab) => tab.path === currentTab)?.label ?? defaultString;
  const navigate = useNavigate();

  return (
    <ButtonMenu
      ref={ref}
      className={clsx(styles.container, className)}
      size="large"
      label={label}
      popoverAlignment="left"
      Icon={IconChervonDown}
    >
      {tabs.map((tab, index) => {
        const { Icon, label, path, disabled } = tab;
        const onAction = () => {
          if (disabled) return;
          if (onSelect?.(tab) === false) return;
          navigate(path);
        };
        return <ButtonMenu.Item onAction={onAction} Icon={Icon} key={index} title={label} />;
      })}
    </ButtonMenu>
  );
};

export default CollapsedTab;
